export default {
  automation: null,
  automations: null,
};
